import { Drawer, Flex } from '@mantine/core';
import { HEADER_HEIGHT } from 'src/UI/app-container/header/Header';
import { IconX } from '@tabler/icons-react';

export type FullScreenDrawerProps = {
  opened: boolean;
  close: () => void;
  children: React.ReactNode;
} & Partial<Omit<React.ComponentProps<typeof Drawer>, 'opened' | 'onClose'>>;

export default function FullScreenDrawer({
  opened,
  close,
  children,
  ...props
}: FullScreenDrawerProps) {
  return (
    <Drawer
      opened={opened}
      onClose={close}
      withCloseButton={false}
      position="bottom"
      size="md"
      styles={{
        content: {
          top: HEADER_HEIGHT,
          height: `calc(100% - ${HEADER_HEIGHT}px)`,
          display: 'flex',
          flexDirection: 'column',
        },
        body: {
          paddingLeft: 54,
          paddingRight: 54,
          height: '100%',
        },
      }}
      {...props}
    >
      <Flex justify={'flex-end'}>
        <IconX size={'20'} onClick={close} />
      </Flex>
      {opened && children}
    </Drawer>
  );
}
